// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"ep-z","imageAndVideoCount":"fp-z","imageAndVideoContainer":"gp-z","viewAllReviews":"hp-z"};